import Selling from "@/components/HowItWorks/Selling";
import MainLayout from "@/components/Layouts/MainLayout";
import { GetStaticProps } from "next";
import getTranslations from "../../lib/getTranslations";
import { getSellingFAQ } from "@/common/utils/faq/faq-selling.utils";

type SellingPageProps = {
  faq?: Record<string, unknown>;
};

const SellingPage = ({ faq }: SellingPageProps) => {
  return <Selling faq={faq} />;
};

SellingPage.getLayout = (page: JSX.Element) => {
  return <MainLayout fullWidthContainer={true}>{page}</MainLayout>;
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await getTranslations(locale, ["selling"])),
      ...(await getSellingFAQ()),
    },
  };
};

export default SellingPage;
